import { Link } from "react-router-dom";

export function DeleteAccountHelp() {
  return (
    <div className="px-5 mx-auto min-h-screen max-w-5xl">
      <div className="my-10">
        <Link
          to={"/help"}
          className="text-sm text-blue-500 underline flex mb-4"
        >
          Back To Help
        </Link>
        <h2 className="text-3xl font-bold">Delete Account</h2>
      </div>

      <div id="page-wrapper">
        <p>
          Please note you will not be able to recover any data after your
          account is deleted.
        </p>

        <p className="my-10">
          <strong className="flex mb-3">Follow the below steps</strong>
          <ul style={{ listStyle: "number" }}>
            <li>
              Login in to{" "}
              <a
                href="https://app.expensehut.com/login"
                target="_blank"
                rel="noreferrer"
                className="text-blue-500 underline"
              >
                Expense Tracker
              </a>
            </li>
            <li>
              Click the hero icon right next to your name in the top right
              corner of the home page, and select <strong>Profile</strong>
            </li>
            <li>Scroll to the bottom and click delete.</li>
          </ul>
        </p>

        <br />
        <hr />
      </div>
    </div>
  );
}
